import { loadChatRouteScript, suppressInjectedChatUi } from "./chatBridge";

const openOliveUpChat = () => {
  if (typeof window === "undefined") return false;
  if (typeof window.oliveUpChatOpen === "function") {
    window.oliveUpChatOpen();
    return true;
  }
  window.dispatchEvent(new CustomEvent("oliveup:open-chat"));
  return true;
};

/**
 * Opens the app-owned chat UI. The backend routing is handled by chatBridge,
 * while external script UI stays suppressed.
 */
export function openLiveChat() {
  try {
    if (typeof window === "undefined") return;
    loadChatRouteScript().catch(() => {});
    suppressInjectedChatUi();

    if (openOliveUpChat()) {
      return;
    }
  } catch (err) {
    console.warn("[OliveUp] openLiveChat error:", err);
  }
}
